/**
 * Error messages filtered from synch-mobile-web Sentry (browser-only).
 * Keep patterns anchored so only known noise is dropped.
 */
export const sentryWebIgnoreErrorPatterns: RegExp[] = [
  /^No sheet found with tag \d+$/,
  // Chrome extension API error with no app stack — injected scripts (password managers,
  // wallets, ad blockers, etc.) messaging a tab that closed or navigated away.
  /^Invalid call to runtime\.sendMessage\(\)\. Tab not found\.$/,
]

export function shouldIgnoreSentryWebError(message: string): boolean {
  return sentryWebIgnoreErrorPatterns.some((pattern) => pattern.test(message))
}
